import { defineComponent, reactive, toRefs, ref, unref, nextTick, getCurrentInstance, watch, computed } from "vue";
import { useRouter } from 'vue-router';
import { ElMessage, ElMessageBox, ElForm } from 'element-plus';
import { deepClone, downloadFile } from "@/utils";
import { listType, getType, delType, addType, updateType, exportType } from "@/api/system1/dict/type";
export default defineComponent({
  name: "Dict",
  components: {},
  props: {},
  setup(props) {
    const formContainer = ref(ElForm);
    const router = useRouter();

    // 获取路由名称作为表格标题
    const tableTitle = computed(() => {
      const route = router.currentRoute.value;
      return route.meta?.title || route.name || '字典管理';
    });
    const state = reactive({
      tableLoading: false,
      saveLoading: false,
      dialogVisible: false,
      title: "添加字典类型",
      multipleSelection: [],
      queryParams: {
        dictName: "",
        dictType: "",
        status: "",
        dateRange: [],
        beginTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 10
      },
      searchFormData: [{
        prop: "keywords",
        label: "关键字",
        placeholder: "字典名称",
        type: "text",
        isSelect: false,
        span: 4
      }],
      formHandle: [{
        label: "搜索",
        type: "primary",
        icon: "el-icon-search",
        class: "btn-liquid",
        handle: () => methods.handleQuery()
      }, {
        label: "重置",
        icon: "el-icon-refresh",
        class: "commonDarkBtn",
        handle: () => methods.resetQuery()
      }],
      //列表顶部顶部操作按钮数据
      buttonsList: [{
        buttonName: "新增",
        buttonStyle: "primary",
        hasPermi: ['system:dict:add'],
        className: 'addBtn',
        buttonIcon: "Plus",
        exp: item => methods.handleAdd(item)
      }, {
        buttonName: "删除",
        buttonStyle: "danger",
        hasPermi: ['system:dict:remove'],
        className: 'deleteBtn',
        buttonIcon: "Delete",
        exp: item => methods.handleDel(item),
        disabledHandle(row) {
          return state.multipleSelection.length > 0 ? false : true;
        }
      }],
      // 请求到的表格数据
      tableData: {
        rows: [],
        total: 0
      },
      tableHeader: [{
        prop: "name",
        label: "字典名称",
        fixed: false,
        type: "text"
      }, {
        prop: "code",
        label: "字典编码",
        fixed: false,
        type: "text",
        clickHandle: row => {
          toRoute('/system/dictData', row.id);
        }
      }, {
        prop: "status",
        label: "状态",
        fixed: false,
        statusList: [{
          label: '启用',
          value: 1
        }, {
          label: '禁用',
          value: 0
        }],
        type: "text"
      },
      // {
      //   prop: "remark",
      //   label: "备注",
      //   fixed: false,
      //   type: "text",
      // },
      // {
      //   prop: "createTime",
      //   label: "创建时间",
      //   fixed: false,
      //   type: "text",
      // },
      {
        prop: "operation",
        label: "操作",
        width: "400px",
        fixed: 'right',
        operation: [{
          name: "修改",
          clickFun: row => methods.handleUpdate(row),
          hasPermi: ['system:dict:edit']
        }, {
          name: "删除",
          clickFun: row => methods.handleDel(row),
          hasPermi: ['system:dict:remove']
        }]
      }],
      // 表单校验
      formRules: {
        name: [{
          required: true,
          message: "字典名称不能为空",
          trigger: "blur"
        }],
        code: [{
          required: true,
          message: "字典编码不能为空",
          trigger: "blur"
        }]
      },
      form: {
        name: "",
        status: 1,
        code: "",
        dictItems: []
      },
      formData: [{
        prop: "name",
        label: "字典名称",
        placeholder: "请输入字典名称",
        type: "text",
        isSelect: true,
        span: 24
      }, {
        prop: "code",
        label: "字典编码",
        placeholder: "请输入字典编码",
        type: "text",
        isSelect: true,
        span: 24
      }, {
        prop: "status",
        label: '状态',
        props: {
          label: 'labelName'
        },
        type: "radio",
        options: [{
          label: "1",
          value: 1,
          labelName: '启用'
        }, {
          label: "0",
          labelName: '禁用',
          value: 0
        }],
        span: 24
      }]
    });
    // 表头初始值
    let key = router.currentRoute.value.name + ":colsettings";
    let colSettings = JSON.parse(localStorage.getItem(key));
    if (colSettings) {
      state.showTableHeader = state.tableHeader.filter(item => {
        if (item.prop == "operation") {
          return true;
        }
        if (colSettings.includes(item.prop)) {
          return true;
        }
        return false;
      });
    } else {
      state.showTableHeader = deepClone(state.tableHeader);
    }
    const toRoute = function (path, id, type, name) {
      router.push({
        path: path,
        query: {
          dictType: id
        }
      });
    };
    const methods = reactive({
      close() {
        state.form = {
          name: "",
          code: "",
          status: 1,
          remark: ""
        };
      },
      handleQuery() {
        methods.getList();
      },
      resetQuery() {
        state.queryParams = {
          keywords: "",
          pageNum: 1,
          pageSize: 10
        }, methods.getList();
      },
      getList() {
        state.tableLoading = true;
        listType(state.queryParams).then(response => {
          state.tableData.rows = response.data.list;
          state.tableData.total = response.data.total;
          state.tableLoading = false;
        });
      },
      //新增
      handleAdd() {
        state.form = {
          name: "",
          status: 1,
          code: "",
          dictItems: []
        };
        state.dialogVisible = true;
        state.title = "添加字典类型";
      },
      /** 修改按钮操作 */
      handleUpdate(row) {
        state.dialogVisible = true;
        state.title = "修改字典类型";
        state.form = {
          ...row
        };
      },
      //表单确定
      submitForm: function () {
        const formRef = unref(formContainer);
        formRef.commonForm.validate(valid => {
          if (valid) {
            state.saveLoading = true;
            if (state.title == "修改字典类型") {
              updateType(state.form).then(response => {
                if (response.code == 0) {
                  ElMessage.success("修改成功");
                  state.saveLoading = false;
                  state.dialogVisible = false;
                  methods.getList();
                }
              }).catch(() => {
                state.saveLoading = false;
              });
            } else if (state.title == "添加字典类型") {
              // 新增
              addType(state.form).then(response => {
                if (response.code == 0) {
                  ElMessage.success("新增成功");
                  state.dialogVisible = false;
                  state.saveLoading = false;
                  methods.resetQuery();
                }
              }).catch(() => {
                state.saveLoading = false;
              });
            }
          }
        });
      },
      //删除
      handleDel(row) {
        if (!row.id && !state.multipleSelection.length) {
          ElMessage.closeAll();
          ElMessage.warning("请至少选择一条数据删除");
          return;
        }
        if (row.id) {
          state.multipleSelection = [];
        }
        state.ids = state.multipleSelection.map(item => item.id);
        let dictIds = row.id || state.ids;
        ElMessageBox.confirm("确定是否删除?", "警告", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          return delType(dictIds);
        }).then(res => {
          ElMessage.closeAll();
          if (res.code == 0) {
            ElMessage.success("删除成功");
          } else {
            ElMessage.warning(res.message);
          }
          methods.getList();
        }).catch(err => {
          console.log(err);
        });
      }
    });
    return {
      ...toRefs(state),
      ...toRefs(methods),
      ...toRefs(router),
      formContainer,
      toRoute,
      tableTitle
    };
  }
});